<template lang="pug">
.report-row
	.report-column.contact-adjust-block(v-if="contacts.length > 0", v-for="(contact, index) in contacts" :key="index")
		h4(v-if="isSecondToo && index === 0") {{ contact.title }}
		h4(v-if="!isSecondToo") {{ contact.title }}

		.report-block(v-if="isSecondToo && index === 0")
			.report-line
				.left Company:
				.right {{ contact.object.company }}
			.report-line
				.left Name:
				.right {{ contact.object.name.last  }}
					span(v-if="contact.object.name.last") ,&nbsp;
					| {{ contact.object.name.first }}
					i( v-if="contact.object.name.first === '' " class="fa fa-exclamation-triangle alert-icon audit-error-icon" aria-hidden="true")
					i( v-if="contact.object.name.last === '' " class="fa fa-exclamation-triangle alert-icon audit-error-icon" aria-hidden="true")
			.report-line
				.left  Address 1:
				.right {{ contact.object.postalAddress().line1 || " " }}
			.report-line
				.left  Address 2:
				.right {{ contact.object.postalAddress().line2 || " " }}
			.report-line
				.left  City:
				.right {{ contact.object.postalAddress().cityText || " " }}
			.report-line
				.left  State:
				.right {{ contact.object.postalAddress().stateText || " " }}
			.report-line
				.left  Postal Code:
				.right {{ contact.object.postalAddress().postalCode || " " }}
			.report-line
				.left  Phone:
				.right
					span {{ (contact.object.phoneNumber().areaCode && contact.object.phoneNumber().areaCode !== undefined) ? '('+ contact.object.phoneNumber().areaCode + ') ' : '' }}
					span {{ (contact.object.phoneNumber().number && contact.object.phoneNumber().number !== undefined ) ? contact.object.phoneNumber().number : ' No Phone Number' }}
			.report-line
				.left  Email:
				.right {{ contact.object.emailAddress().address }}
					i( v-if="!contact.object.emailAddress().address " class="fa fa-exclamation-triangle alert-icon audit-error-icon" aria-hidden="true")
			br
			p: b Decision Marker same as Report Signer

		.report-block(v-if="!isSecondToo")
			.report-line
				.left Company:
				.right {{ contact.object.company }}
			.report-line
				.left Name:
				.right {{ contact.object.name.last }}
					span(v-if="contact.object.name.last") ,&nbsp;
					| {{ contact.object.name.first }}
					i( v-if="contact.object.name.first === '' " class="fa fa-exclamation-triangle alert-icon audit-error-icon" aria-hidden="true")
					i( v-if="contact.object.name.last === '' " class="fa fa-exclamation-triangle alert-icon audit-error-icon" aria-hidden="true")
			.report-line
				.left  Address 1:
				.right {{ contact.object.postalAddress().line1 || " " }}
			.report-line
				.left  Address 2:
				.right {{ contact.object.postalAddress().line2 || " " }}
			.report-line
				.left  City:
				.right {{ contact.object.postalAddress().cityText || " " }}
			.report-line
				.left  State:
				.right {{ contact.object.postalAddress().stateText || " " }}
			.report-line
				.left  Postal Code:
				.right {{ contact.object.postalAddress().postalCode || " " }}
			.report-line
				.left  Phone:
				.right {{ '('+contact.object.phoneNumber().areaCode + ') ' + contact.object.phoneNumber().number }}
			.report-line
				.left  Email:
				.right {{ contact.object.emailAddress().address }}
					i( v-if="!contact.object.emailAddress().address " class="fa fa-exclamation-triangle alert-icon audit-error-icon" aria-hidden="true")
</template>
<script>
export default {
	name: 'contacts-block',
	props: ['contacts', 'isSecondToo']
}
</script>



// WEBPACK FOOTER //
// src/common/components/contacts.vue